declare namespace $ {

	type $mol_svg_circle__radius_shm_hitalama_map_touch_selection_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['radius'] >
	>
	type $mol_svg_circle__pos_x_shm_hitalama_map_touch_selection_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['pos_x'] >
	>
	type $mol_svg_circle__pos_y_shm_hitalama_map_touch_selection_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['pos_y'] >
	>
	type $mol_svg_circle__radius_shm_hitalama_map_touch_selection_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['radius'] >
	>
	type $mol_svg_circle__pos_x_shm_hitalama_map_touch_selection_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['pos_x'] >
	>
	type $mol_svg_circle__pos_y_shm_hitalama_map_touch_selection_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['pos_y'] >
	>
	type $mol_svg__attr_shm_hitalama_map_touch_selection_7 = $mol_type_enforce<
		({ 
			'viewBox': string,
		})  & ReturnType< $mol_svg['attr'] >
		,
		ReturnType< $mol_svg['attr'] >
	>
	type $mol_svg__style_shm_hitalama_map_touch_selection_8 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_hitalama_map_touch_selection['point_x'] >,
			'top': ReturnType< $shm_hitalama_map_touch_selection['point_y'] >,
		})  & ReturnType< $mol_svg['style'] >
		,
		ReturnType< $mol_svg['style'] >
	>
	type $mol_svg__sub_shm_hitalama_map_touch_selection_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_svg['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_touch_selection_10 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_hitalama_map_touch_selection['label_left'] >,
			'top': ReturnType< $shm_hitalama_map_touch_selection['label_top'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_touch_selection_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_touch_selection extends $mol_view {
		point_x( ): string
		point_y( ): string
		Track( ): $mol_svg_circle
		Progress( ): $mol_svg_circle
		Ring( ): $mol_svg
		label_left( ): string
		label_top( ): string
		Label( ): $mol_view
		label_views( ): readonly(any)[]
		point( ): readonly(number)[]
		active( ): boolean
		moving( ): boolean
		attr( ): ({ 
			'active': ReturnType< $shm_hitalama_map_touch_selection['active'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=selection.view.tree.d.ts.map